import {
  SizeGuideSection 
} from "../size-guide-section"

const pvcWaderTableData = {
  headers: [
    [
      {
        content: "PVC Wader",
        colSpan: 6,
      },
    ],
    [
      {
        content: "Wader Size",
      },
      {
        content: "Shoes Size",
      },
      {
        content: "Total Length(In)",
      },
      {
        content: "Inseam(In)",
      },
      {
        content: "Chest(In)",
      },
      {
        content: "Hip(In)",
      },
    ],
  ],
  data: [
    [
      {
        content: "5" 
      },
      {
        content: "5" 
      },
      {
        content: "54.3" 
      },
      {
        content: "34.7" 
      },
      {
        content: "49.6" 
      },
      {
        content: "49.6" 
      },
    ],
    [
      {
        content: "6" 
      },
      {
        content: "6" 
      },
      {
        content: "54.4" 
      },
      {
        content: "34.7" 
      },
      {
        content: "49.6" 
      },
      {
        content: "49.6" 
      },
    ],
    [
      {
        content: "7" 
      },
      {
        content: "7" 
      },
      {
        content: "54.7" 
      },
      {
        content: "35" 
      },
      {
        content: "51.2" 
      },
      {
        content: "51.2" 
      },
    ],
    [
      {
        content: "8" 
      },
      {
        content: "8" 
      },
      {
        content: "54.7" 
      },
      {
        content: "35" 
      },
      {
        content: "51.2" 
      },
      {
        content: "51.2" 
      },
    ],
    [
      {
        content: "9" 
      },
      {
        content: "9" 
      },
      {
        content: "54.7" 
      },
      {
        content: "35.6" 
      },
      {
        content: "52" 
      },
      {
        content: "52" 
      },
    ],
    [
      {
        content: "10" 
      },
      {
        content: "10" 
      },
      {
        content: "55.1" 
      },
      {
        content: "35.6" 
      },
      {
        content: "52.8" 
      },
      {
        content: "52.8" 
      },
    ],
    [
      {
        content: "11" 
      },
      {
        content: "11" 
      },
      {
        content: "55.1" 
      },
      {
        content: "35.6" 
      },
      {
        content: "52.8" 
      },
      {
        content: "52.8" 
      },
    ],
    [
      {
        content: "12" 
      },
      {
        content: "12" 
      },
      {
        content: "54.5" 
      },
      {
        content: "36" 
      },
      {
        content: "55.1" 
      },
      {
        content: "55.1" 
      },
    ],
    [
      {
        content: "13" 
      },
      {
        content: "13" 
      },
      {
        content: "54.5" 
      },
      {
        content: "36" 
      },
      {
        content: "55.1" 
      },
      {
        content: "55.1" 
      },
    ],
  ],
}

export const PvcWader = ({
  className
}: {
  className?: string
}) => {
  return <SizeGuideSection 
    title='PVC Wader'
    tableData={pvcWaderTableData}
    className={className}
  />
}
